import { StatusRenderer } from "../primitives/StatusRenderer";
import { CellStatus } from "../primitives/StatusIndicator";
import { FailedCell } from "../ComplexCells/FailedCell";
import { BaseCell } from "../primitives";
import { useCellActions } from "../hooks/useCellActions";

import { ColumnType, ReportCell, ReportColumn } from "@/types/evaluate";

export const StatusCell = ({
  cell,
  column,
  isColumnSelected,
}: {
  cell: ReportCell;
  column: ReportColumn;
  isColumnSelected: boolean;
}) => {
  const { actions } = useCellActions({
    cell,
    column,
    showRetry: true,
    showFullscreen: cell?.status === CellStatus.FAILED,
    showCopy: cell?.status === CellStatus.FAILED,
    showOpenRequest:
      cell?.status === CellStatus.FAILED &&
      (column.column_type === ColumnType.PROMPT_TEMPLATE ||
        column.column_type === ColumnType.WORKFLOW),
  });

  if (!cell) {
    return <StatusRenderer status={CellStatus.LOADING} cellType="default" />;
  }

  if (cell?.status === CellStatus.RUNNING || cell?.status === CellStatus.QUEUED) {
    return (
      <BaseCell isSelected={isColumnSelected} actions={actions}>
        <StatusRenderer status={cell.status} cellType="default" />
      </BaseCell>
    );
  }

  if (cell.status === CellStatus.FAILED) {
    return (
      <BaseCell isSelected={isColumnSelected} actions={actions}>
        <FailedCell cell={cell} column={column} />
      </BaseCell>
    );
  }
};
